<template>
  <section>
    <sweet-modal ref="modal" overlay-theme="dark">
      <form @submit.prevent="submitConfirmPrice" v-if="serviceRequest && order">

        <!-- Payment type -->
        <div class="card shadow-sm">
          <div class="card-body text-left pb-2">
            #{{ order.code }} - <span
            v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
          </div>
          <div class="card-body">
            <section v-if="serviceRequest.promotion_cost">
              <div class="radio" v-if="serviceRequest.payment_status === 0">
                <label class="custom-inline">
                <span
                  class="label-span">{{ $t('message.service_request.service_request_payment_pay_promotion') }}</span>
                  <input type="radio" name="type_payment" required
                         v-model="form.payment_type"
                         value="promotion">
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="radio" v-if="serviceRequest.payment_status === 3">
                <label class="custom-inline">
                  <span class="label-span">{{ $t('message.service_request.service_request_payment_pay_total') }}</span>
                  <input type="radio" name="type_payment" required
                         v-model="form.payment_type"
                         value="full">
                  <span class="checkmark"></span>
                </label>
              </div>
              <hr v-if="serviceRequest.payment_status === 3">
              <div class="radio" v-if="hasPaidServiceRequestCost(serviceRequest, 'promotion')">
                <label class="custom-inline">
                  <span class="label-span">
                    {{ serviceRequest && serviceRequest.payment_status === 1 ? $t('message.service_request.service_request_payment_pay_remaining') : $t('message.service_request.service_request_payment_pay_deposit') }}
                    <span class="text-remark" v-if="serviceRequest.payment_status === 3">
                      <br>{{ $t('message.service_request.service_request_payment_pay_remaining_balance_remark') }}
                    </span>
                  </span>
                  <input type="radio" name="type_payment"
                         v-model="form.payment_type" :required="serviceRequest.payment_status === 1"
                         value="deposit">
                  <span class="checkmark"></span>
                </label>
              </div>
            </section>

            <section v-else>
              <div class="radio" v-if="serviceRequest.payment_status === 0">
                <label class="custom-inline" for="type_payment1">
                  <span class="label-span">{{ $t('message.service_request.service_request_payment_pay_total') }}</span>
                  <input type="radio" name="type_payment" required
                         v-model="form.payment_type"
                         id="type_payment1" value="full">
                  <span class="checkmark"></span>
                </label>
              </div>
              <hr v-if="serviceRequest.payment_status === 0">
              <div class="radio">
                <label class="custom-inline" for="type_payment2">
                              <span class="label-span">
                                {{ serviceRequest && serviceRequest.payment_status === 1 ? $t('message.service_request.service_request_payment_pay_remaining') : $t('message.service_request.service_request_payment_pay_deposit') }}
                                <span class="text-remark" v-if="serviceRequest.payment_status === 0">
                                  <br>{{ $t('message.service_request.service_request_payment_pay_remaining_balance_remark') }}
                                </span>
                              </span>
                  <input type="radio" name="type_payment"
                         v-model="form.payment_type" :required="serviceRequest.payment_status === 1"
                         id="type_payment2" value="deposit">
                  <span class="checkmark"></span>
                </label>
              </div>
            </section>

            <template v-if="calculateServiceCost">
              <hr>
              <div class="row no-gutters footer">
                <div class="col-6 text-left">
                  <strong>{{ $t('message.service_request.all_amount_due') }}</strong>
                </div>
                <div class="col-6 text-right">
                  <strong v-if="form.payment_type">{{ calculateServiceCost | currency }}</strong>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- Payment method -->
        <div class="card shadow-sm" v-if="form.payment_type">
          <div class="card-body text-left pb-2">
            {{ $t('message.menu.payment_method') }}
          </div>
          <div class="card-body">
            <div class="radio text-left">
              <template v-if="user">
                <div>
                  <label class="custom-inline" for="payment_method1">
                    <span class="label-span">{{ $t('message.payment_method.credit_debit_card') }}  </span>
                    <input type="radio" name="payment_method" required
                           v-model="form.payment_method"
                           id="payment_method1" value="credit_card">
                    <span class="checkmark"></span>
                  </label>
                  <div v-if="form.payment_method === 'credit_card'">
                    <div class="row no-gutters d-flex h-100" v-if="payment && !addingNewCard">
                      <div class="col-6">
                        <payment-small :payment="payment"/>
                      </div>
                      <div class="col-6 text-right align-self-center">
                        <button type="button"
                                class="btn btn-link text-primary-link"
                                @click="addingNewCard = true">{{ $t('message.button.change_new_card') }}
                        </button>
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-right pt-4 pb-2">
                        <button type="button"
                                class="btn btn-link text-primary-link"
                                @click="addingNewCard = false">{{ $t('message.button.cancel') }}
                        </button>
                      </div>
                      <payment-form ref="paymentForm" :paymentData="form.paymentData"/>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <i class="fas fa-3x fa-circle-notch fa-spin"></i>
              </template>
            </div>
            <hr>
            <div class="radio">
              <label class="custom-inline" for="payment_method2">
                <span class="label-span">{{ $t('message.payment_method.bank_transfer') }} </span>
                <input type="radio" name="payment_method"
                       v-model="form.payment_method"
                       id="payment_method2" value="bank_transfer">
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>

        <!-- Bank transfer information -->
        <div class="card shadow-sm" v-if="form.payment_method === 'bank_transfer'">
          <div class="card-body text-left">
            <img :src="globalState.bankAccountData.image_url" height="60" class="rounded" alt="">
            <div class="pt-3">
              <h3 class="m-0">{{ $t('message.bank_transfer.account_name') }}: {{ globalState.bankAccountData | multiLangName }}</h3>
            </div>
            <div class="row py-3 no-gutters d-flex h-100">
              <div class="col-8 align-self-center">
                <h3 class="m-0">
                  {{ $t('message.bank_transfer.account') }}: {{ globalState.bankAccountData.account_number }}
                </h3>
              </div>
              <div class="col-4 text-right align-self-center">
                <button type="button"
                        class="btn btn-outline-info"
                        @click="isCopied = true"
                        v-clipboard:copy="globalState.bankAccountData.account_number">
                  {{ isCopied ? $t('message.button.copied') : $t('message.button.copy') }}
                </button>
              </div>
            </div>
            <vue-dropzone ref="vueDropzone"
                          id="dropzone"
                          class="dropzone-dashed"
                          :options="dropzoneOptions"
                          @vdropzone-file-added="handleFileUpload"
                          @vdropzone-max-files-exceeded="vueDropZoneMaxFilesExceeded"/>
            <div class="text-remark py-2">
              {{ $t('message.bank_transfer.transfer_picture_remark01') }}
            </div>
          </div>
        </div>

        <div class="alert alert-warning" role="alert" v-if="errorMessage">
          <i class="fas fa-exclamation-circle -status-alert"></i> {{ errorMessage }}
        </div>

        <div class="row no-gutters px-2 d-flex h-100 pt-4" v-if="form.payment_type && form.payment_method">
          <div class="col-6 text-left align-self-center">
            <h3 class="-status-new m-0">
              <strong>{{ calculateServiceCost | currency }}</strong>
            </h3>
            <span>{{ $t('message.service_request.all_vat_included') }}</span>
          </div>
          <div class="col-6 text-right align-self-center">
            <button type="submit"
                    :disabled="isSubmitting"
                    class="btn btn-info btn-lg">
              {{ (isSubmitting) ? $t('message.processing') : $t('message.button.confirm_payment') }}
            </button>
          </div>
        </div>
      </form>
    </sweet-modal>
  </section>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  import PaymentForm from '../../payment/PaymentForm'
  import Loader from '../../loader/Loader'
  import PaymentSmall from '../../payment/PaymentSmall'
  import vue2Dropzone from 'vue2-dropzone'

  export default {
    components: {
      Loader,
      PaymentForm,
      PaymentSmall,
      SweetModal,
      vueDropzone: vue2Dropzone
    },
    props: {
      order: Object,
      serviceRequest: Object
    },
    data () {
      return {
        form: {
          payment_type: null,
          payment_method: null,
          paymentData: {
            name: null,
            number: null,
            expirationDate: '',
            securityCode: null,
            savePayment: true,
            displaySavePayment: true,
            isDefault: false
          }
        },
        omiseTokens: {
          secureToken: null,
          token: null
        },
        dropzoneOptions: {
          acceptedFiles: 'image/*',
          url: 'https://beneat.co',
          thumbnailWidth: 160,
          thumbnailHeight: 160,
          maxFilesize: 5,
          dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.attach_slip_here')}`,
          headers: {'Content-Type': 'multipart/form-data'},
          addRemoveLinks: true,
          autoProcessQueue: false,
          maxFiles: 1
        },
        addingNewCard: false,
        errorMessage: null,
        isSubmitting: false,
        isCopied: false
      }
    },
    watch: {
      'omiseTokens.token': function (newVal, oldVal) {
        if (this.omiseTokens.secureToken && newVal) {
          const submitData = {
            user_id: this.user.id,
            token: this.omiseTokens.secureToken,
            // url ที่ต้องการให้ user กลับมาหลังจากที่ทำการ check secure กับ omise เรียบร้อย
            // คือ PaymentServiceRequestValidation.vue
            return_uri: location.origin + '/payments-service-request/' + this.user.id + '/validate',
            omise_account: 'hellobeneat'
          }
          this.checkOmiseSecure(submitData)
        }
      }
    },
    computed: {
      calculateServiceCost () {
        let totalCost = null
        if (this.serviceRequest) {
          const paymentType = this.form.payment_type
          const hasPaidPromotionCost = this.hasPaidServiceRequestCost(this.serviceRequest, 'promotion')
          const hasPaidDepositCost = this.hasPaidServiceRequestCost(this.serviceRequest, 'deposit')
          const promotionCost = this.serviceRequest.promotion_cost
          switch (paymentType) {
            case 'full':
              totalCost = this.serviceRequest.service_cost
              if (promotionCost != null && hasPaidPromotionCost) {
                totalCost = totalCost - promotionCost
              }
              break
            case 'deposit':
              totalCost = parseFloat((this.serviceRequest.service_cost / 2)).toFixed(2)
              if (promotionCost != null && hasPaidPromotionCost && !hasPaidDepositCost) {
                totalCost = totalCost - promotionCost
              }
              break
            case 'promotion':
              totalCost = this.serviceRequest.promotion_cost
              break
          }
        }
        return totalCost
      },
      ...mapGetters({
        globalState: 'globalVal/getState',
        payment: 'payment/getPayment',
        user: 'auth/getUser'
      })
    },
    methods: {
      hasPaidServiceRequestCost (serviceRequest, paymentType) {
        let hasPaid = false
        const serviceRequestPayments = serviceRequest.service_request_payments
        if (serviceRequestPayments.length > 0) {
          for (const serviceRequestPayment of serviceRequestPayments) {
            if (serviceRequestPayment.payment_type === paymentType) {
              hasPaid = true
              break
            }
          }
        }
        return hasPaid
      },
      checkOmiseSecure (submitData) {
        const url = 'payments/' + this.user.id + '/check-omise-secure'
        axios.post(url, submitData)
          .then(res => {
            const response = res.data
            if (!response.error) {
              this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', response.omise_charge_id)
              // พา user ไปหน้า check secure บัตรของ omise
              window.location = response.authorize_uri
            } else {
              this.$swal({text: 'Error payment:' + response.message, type: 'error'})
              this.omiseTokens.secureToken = null
              this.omiseTokens.token = null
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      validation () {
        let result = true
        this.errorMessage = null
        if (this.form.payment_method === 'credit_card') {
          if (this.payment && this.payment.is_expired && !this.addingNewCard) {
            this.errorMessage = this.$i18n.t('message.service_request.service_request_payment_error1')
            result = false
          }
        } else if (this.form.payment_method === 'bank_transfer') {
          const queueFiles = this.$refs.vueDropzone.getQueuedFiles()
          if (queueFiles.length === 0) {
            this.errorMessage = this.$i18n.t('message.service_request.service_request_payment_error2')
            result = false
          }
        }
        return result
      },
      async submitConfirmPrice () {
        if (this.validation()) {
          if (this.form.payment_method === 'credit_card') {
            if (this.payment === null || this.addingNewCard) {
              await this.newPaymentBooking()
            } else {
              await this.addServiceRequestPayment()
            }
          } else if (this.form.payment_method === 'bank_transfer') {
            await this.addServiceRequestPayment()
          }
        }
      },
      async addServiceRequestPayment () {
        this.isSubmitting = true
        let formData = new FormData()
        formData.append('user_id', this.serviceRequest.user_id)
        formData.append('service_request_id', this.serviceRequest.id)
        formData.append('payment_type', this.form.payment_type)
        formData.append('payment_method', this.form.payment_method)
        if (this.form.payment_method === 'bank_transfer') {
          const queueFiles = this.$refs.vueDropzone.getQueuedFiles()
          if (queueFiles[0]) {
            formData.append('slip_image', queueFiles[0])
          }
        }
        formData.append('id', this.serviceRequest.id)
        let {data} = await axios.post(this.globalState.customerApiUrl + '/service-requests/' + this.serviceRequest.id + '/payment', formData)
        if (!data.error) {
          this.isSubmitting = false
          this.$refs.modal.close()
          this.$swal({text: this.$i18n.t('message.success'), type: 'success'})
          this.$emit('fetchData')
        } else {
          this.isSubmitting = false
          this.$refs.modal.close()
          this.$swal({text: 'Error: ' + data.message, type: 'error'})
        }
      },
      async newPaymentBooking () {
        // ตรวจสอบฟอร์ม
        if (this.$refs.paymentForm.paymentFormValidation()) {
          this.isSubmitting = true
          const tmpConfirmPaymentData = {...this.form}
          tmpConfirmPaymentData.service_request_id = this.serviceRequest.id

          // บันทึกตัวแปรเข้า temp data ชั่วคราว จะเอามาใช้ใน PaymentServiceRequestValidation.vue
          this.$store.commit('serviceRequest/SET_TMP_PAYMENT_CONFIRM_DATA', tmpConfirmPaymentData)

          // แปลงข้อมูลการ์ดจากข้อมูลที่กรอกเข้ามา
          const cardNumber = this.form.paymentData.number.replace(/\s+/g, '')
          let arrExpiration = this.form.paymentData.expirationDate.split('/')
          const expirationMonth = arrExpiration[0]
          const expirationYear = 2000 + parseInt(arrExpiration[1])
          const card = {
            'name': this.form.paymentData.name,
            'number': cardNumber,
            'expiration_month': expirationMonth,
            'expiration_year': expirationYear,
            'security_code': this.form.paymentData.securityCode
          }

          // Perform omise process
          this.omiseTokens.secureToken = null
          this.omiseTokens.token = null

          // Get token from omise secure for otp
          window.Omise.setPublicKey(this.globalState.omisePublicKey)
          window.Omise.createToken('card', card, (statusCode, response) => {
            if (statusCode === 200 && response.object === 'token') {
              this.isSubmitting = false
              const omiseToken = response.id
              this.omiseTokens.secureToken = omiseToken
              // Get token from omise non-secure for adding omise customer id
              window.Omise.setPublicKey(this.globalState.omisePublicKey)
              window.Omise.createToken('card', card, (statusCode, response) => {
                if (statusCode === 200 && response.object === 'token') {
                  const omiseToken = response.id
                  // หลังจากนี้ watch omiseTokens.token จะทำงานต่อ
                  this.omiseTokens.token = omiseToken
                  this.$store.commit('payment/SET_TMP_OMISE_TOKEN', omiseToken)
                } else {
                  const alertText = 'Error: ' + response.message
                  this.$swal({text: alertText})
                }
              })
            } else {
              this.isSubmitting = false
              const alertText = 'Error: ' + response.message
              this.$swal({text: alertText})
            }
          })
        }
      },
      async getUserDetail () {
        if (this.serviceRequest) {
          let {data} = await axios.get('users/' + this.serviceRequest.user_id)
          this.user = data.user
          this.$refs.modal.open()
        } else {
          this.$swal({
            text: 'Can\'t get Service Request Data!',
            type: 'error'
          })
        }
      },
      openModal (serviceRequestId) {
        this.form = {
          payment_type: null,
          payment_method: null,
          paymentData: {
            name: null,
            number: null,
            expirationDate: '',
            securityCode: null,
            savePayment: true,
            displaySavePayment: true,
            isDefault: false
          }
        }
        this.addingNewCard = false
        this.isSubmitting = false
        this.serviceRequestId = serviceRequestId
        this.$refs.modal.open()
      },
      handleFileUpload (file) {
        if (file) {
          this.errorMessage = null
        }
      },
      vueDropZoneMaxFilesExceeded (file) {
        this.$refs.vueDropzone.removeAllFiles()
        this.$refs.vueDropzone.addFile(file)
      }
    },
    mounted () {
      this.$store.dispatch('payment/LOAD_PAYMENT_DETAIL', this.user.id)
    }
  }
</script>

<style scoped lang="scss">

  .footer {
    font-weight: bold;
  }

  .box-body {
    color: black;
  }

  /* The container */
  .custom-inline {
    display: block;
    position: relative;
    padding-left: 0;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: left;

    input {
      position: absolute;
      right: 0;
      opacity: 0;
      cursor: pointer;
    }
  }


  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    right: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .custom-inline:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .custom-inline input:checked ~ .checkmark {
    background-color: #2196F3;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .custom-inline input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .custom-inline .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/Components/PaymentModal.vue